export default __webpack_public_path__ + "static/door9-7407d8146d638dc3a6c0c65a2ebcef72.jpg";